import { IApplicationState } from '../types';
import { IToastState } from './reducer/reducer';

export const getToastProps = (state: IApplicationState): IToastState =>
  state.toast;
